/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/Products';
import s from '../Products.css';
import reactTabs from '!!isomorphic-style-loader!css-loader!../../../../node_modules/react-tabs/style/react-tabs.css';

class FacingBrickRockface extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <div className={s.carousel}>
              <Carousel
                autoplay
                initialSlideHeight={431}
                initialSlideWidth={655}
                wrapAround
              >
                <img
                  alt="Rockface Tiles"
                  src="/images/products/MB_RF-02K.jpg"
                />
              </Carousel>
            </div>
            <hr />
            <h1>Specifications</h1>
            <Tabs className={s.root.reactTabs}>
              <TabList>
                <Tab>Rockface Tile 02K</Tab>
              </TabList>
              <TabPanel>
                <table>
                  <tbody>
                    <tr className={s.alt}>
                      <th>Product Code</th>
                      <td colSpan="2">MB/RFT-02K</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td colSpan="2">Rockface Tile</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Manufacturer</th>
                      <td colSpan="2">Maybricks, Malaysia</td>
                    </tr>
                    <tr className={s.alt}>
                      <th>Image</th>
                      <td colSpan="2">
                        <img
                          src="/images/products/MB_RF-02K.jpg"
                          width="100%"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s, reactTabs)(FacingBrickRockface);



// WEBPACK FOOTER //
// ./src/routes/products/facing-brick-rockface/FacingBrickRockface.js